var module = angular.module('octopusApp.projects');

module.directive("variableValueEditor", function($uibModal, variableTypes, $timeout) {
    return {
        restrict: 'E',
        replace: true,
        templateUrl: 'areas/projects/variables/variable_value_editor.html',
        link: function(scope, element) {

            scope.style = {
               "z-index": "1030",
                "position": "absolute",
                "top": scope.container.offset().top + "px",
                "left": scope.container.offset().left + "px"
            };

            scope.promptText = "Prompt";
            scope.variableTypes = variableTypes.all();

            if (!scope.state.type) {
                scope.state.type = variableTypes.string().name;
            }

            $timeout(function(){
                angular.element(element[0].querySelector(".var-edit")).focus();
            });

            scope.handleKeyDown = function(e) {
                if (e.which === $.ui.keyCode.ENTER && e.ctrlKey) {
                    scope.save();
                } else if (e.which === $.ui.keyCode.ESCAPE) {
                    e.preventDefault();
                    scope.cancel();
                } else if (e.which === $.ui.keyCode.TAB && e.shiftKey) {
                    e.preventDefault();
                    scope.gridArgs.grid.navigatePrev();
                    return false;
                } else if (e.keyCode === $.ui.keyCode.LEFT || e.keyCode === $.ui.keyCode.RIGHT || (e.keyCode === $.ui.keyCode.ENTER && e.shiftKey)) {
                    e.stopImmediatePropagation();
                } else if (e.keyCode === $.ui.keyCode.TAB) {
                    e.preventDefault();
                    scope.gridArgs.grid.navigateNext();
                    return false;
                }
            };

            scope.save = function() {
                scope.gridArgs.commitChanges();
            };

            scope.cancel = function(e) {
                if (e) {
                    e.preventDefault();
                }
                scope.reset();
                scope.gridArgs.cancelChanges();
                return false;
            };

            scope.reset = function() {
                scope.state.value = scope.original.value;
                scope.state.isSensitive = scope.original.isSensitive;
                scope.state.prompt = scope.original.prompt;
            };

            scope.showEditor = function() {

                var controller = angular.element(scope.container).scope();
                controller.showValueEditor(function(result) {
                    if (result) {
                        scope.state = result;
                        scope.save();
                    } else {
                        scope.cancel();
                    }
                });
            };
        }
    };
});



//////////////////
// WEBPACK FOOTER
// ./app/areas/projects/variables/variable_value_editor.js
// module id = 6936433336725976
// module chunks = 1